<template>
  <dd class="join_privacy">
    <termsInner />
  </dd>
</template>
<script>
import termsInner from '../agree/termsInner'

export default {
  name: 'termsText',
  components: {
    termsInner,
  },
}
</script>
<style>
.join_privacy {
  width: 650px;
  padding: 100px 40px;
  margin: 0 auto;
}
</style>
